import QuestionViewItem from './QuestionViewItem';
export default QuestionViewItem;
